import { render, staticRenderFns } from "./CatalogCreate.vue?vue&type=template&id=8b2918ac"
import script from "./CatalogCreate.vue?vue&type=script&lang=ts"
export * from "./CatalogCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports